import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FormField from '../../components/FormField';
import Screen from '../../components/Screen';
import SubmitButton from '../../components/SubmitButton';
import { FormContext } from '../../hooks/formContext';
import QuestionList from '../checklist/QuestionList';

export default function Default() {
    const {
        loading,
        data, setData,
        question, setQuestion,
        onDublicateQuestiuon,
        newForm,
        onAddQuestiuon,
        changeForm,
        removeForm,
        sortOrder, setSortOrder,
        editIndex, setEditIndex,
        titleField
    } = useContext(FormContext)
    const location = useLocation()
    useEffect(() => {
        if (location.state) setData({ title: location.state?.title, questions: location.state?.questions, ...location.state })
    }, [])

    return (
        <Screen
            loading={loading == "initial"}
            faqsId={"add_forms"}
            flow={[
                { label: `Add form`, to: `/add-form` },
                { label: "Home", to: "/" },
                { label: `Add form`, to: `/add-form` },
            ]}>

            <div className="d-flex justify-content-end mb-3 gap-3">
                {
                    <>
                        <SubmitButton
                            title={location.state
                                ? "Update Form" : "Save Form"}
                            loading={loading == "new" || loading == "update"}
                            onClick={() =>
                                location.state
                                    ? changeForm()
                                    : newForm()
                            }
                            color={"success"}
                            loaderColor={"white"}
                            disabled={!data.title || data.questions?.length < 1}
                        />
                        {(
                            <SubmitButton
                                icon={<i className="bi bi-trash3"></i>}
                                loading={loading == "delete"}
                                onClick={() => removeForm()}
                                color={"danger"}
                                loaderColor={"white"}
                                disabled={false}
                            />
                        )}
                    </>
                }
            </div>
            <div className="col-md-12 col-12">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Add Form Title</h5>
                        <FormField item={titleField} />
                    </div>
                </div>
            </div>
            <div className="row">
                {/* New Question */}
                {/* Question List */}
                <div className="col-xl-12">
                    <QuestionList
                        isForm={true}
                        questions={data?.questions}
                        setQuestion={setQuestion}
                        setQuestions={(questions) => setData({ ...data, questions })}
                        setData={setData}
                        setEditIndex={setEditIndex}
                        setSortOrder={setSortOrder}
                        question={question}
                        onAddQuestiuon={onAddQuestiuon}
                        sortOrder={sortOrder}
                        editIndex={editIndex}
                        onDublicateQuestiuon={onDublicateQuestiuon}
                    />
                </div>
            </div>
        </Screen>
    )
}
